import React from "react";
import "../Styles/Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";

const Header = (props) => {
  return (
    <>
      <div className="twoColContainerH">
        <div className="firstColHeaderClient">
          <a href="https://twojeskd.pl">
            <img
              alt="logo"
              className="logoImageHeader"
              src="https://pskd.ftpeople.pl/wp-content/uploads/2023/12/logo.png.webp"
            />{" "}
          </a>
        </div>
        <div className="secondColHeaderClient">
          <span>
            <a
              className="headerLinkClient"
              href="https://twojeskd.pl"
              rel="noreferrer"
              target="_blank"
            >
              Strona główna
            </a>
          </span>
          <span>
            <a
              className="headerLinkClient"
              href="https://twojeskd.pl/#second"
              rel="noreferrer"
              target="_blank"
            >
              Jak to działa?
            </a>
          </span>
          <span>
            <a
              className="headerLinkClient"
              href="https://twojeskd.pl/blog"
              rel="noreferrer"
              target="_blank"
            >
              Aktualności
            </a>
          </span>
          <span>
            <a
              className="headerLinkClient"
              href="https://twojeskd.pl/#sixth"
              rel="noreferrer"
              target="_blank"
            >
              Kontakt
            </a>
          </span>
        </div>
        <div className="thirdColHeader">
          <div className="socialIconHeaderClient">
            <a
              className="socialLink"
              href="https://www.facebook.com/people/Twoje-SKD/61555370602965/"
              target="_blank"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
